import axios from 'axios';
import {api} from '../../constants/api';

export const getFileMonitorInstaller = async () => {
  const response = await axios.get(api.GET_FILE_MONITOR_INSTALLER);
  if (response.data.errorCode !== 0) throw new Error(`API error: ${response.data.errorCode}`);
  return response.data.body.file;
};